import React from 'react';
import { Spotlight } from './Spotlight';
import { Phone } from 'lucide-react';
export const FinalCTA = () => {
  return <section className="py-24 bg-beige-100 relative overflow-hidden text-center" data-id="element-99">
      <Spotlight className="opacity-60" data-id="element-100" />

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-101">
        <h2 className="text-4xl md:text-5xl font-serif text-neutral-900 mb-6" data-id="element-102">
          Tu transformación empieza con una{' '}
          <span className="metallic-gold-text italic" data-id="element-103">decisión.</span>
        </h2>
        <p className="text-xl text-neutral-600 mb-10 font-light" data-id="element-104">
          Stefania Becerra te espera en Long Island City, Queens.
        </p>

        <a href="https://wa.me/13479909488?text=Hola%2C%20me%20gustar%C3%ADa%20agendar%20una%20cita%20%E2%9C%A8" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center metallic-gold-button text-white px-10 py-5 rounded-full text-lg font-medium shadow-xl hover:-translate-y-1 transition-all" data-id="element-105">
          <Phone className="w-5 h-5 mr-3" data-id="element-106" />
          Agenda por WhatsApp
        </a>

        <p className="mt-8 text-sm text-neutral-500 uppercase tracking-widest font-medium" data-id="element-107">
          Atención con cita previa
        </p>
      </div>
    </section>;
};